import { render, staticRenderFns } from "./ManualChatButton.vue?vue&type=template&id=4c21e965"
import script from "./ManualChatButton.vue?vue&type=script&lang=js"
export * from "./ManualChatButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports